import { SizeChartOpenEvent, ThemeEvents } from '@theme/events';
// begin new size guide drawer 
// (() => {
//   document.body.classList.add('has-size-chart');

//   document.addEventListener('click', (event) => {
//     const trigger = event.target instanceof Element ? event.target.closest('.size-chart-button') : null;
//     if (trigger) {
//       document.dispatchEvent(new SizeChartOpenEvent());
//     }
//   });

//   const hasNewDrawer = document.querySelector('size-guide-drawer-component');
//   if (hasNewDrawer) return;

//   let interval;
//   let counter = 0;
//   const duration = 250;
//   const limit = 40;

//   interval = setInterval(() => {
//     if (document.getElementsByClassName('Avada-inline-button').length) {
//       document.addEventListener(ThemeEvents.sizeChartOpen, () => {
//         const avadaButton = document.querySelector('#Avada-SC-button .Avada-inline-button');
//         if (!avadaButton?.classList.contains('openning')) {
//           avadaButton?.classList.add('openning');
//           avadaButton?.click();
//           setTimeout(() => {
//             avadaButton?.classList.remove('openning');
//           }, 1000);
//         }
//       });
//       clearInterval(interval);
//     } else if (counter === limit) {
//       clearInterval(interval);
//     }
//     counter += 1;
//   }, duration);
// })();

// end new size guide drawer

(()=>{
  let interval,
  counter = 0,
  duration = 250,
  limit = 40;
  interval = setInterval( () => {
    if(document.getElementsByClassName('Avada-inline-button').length){
      document.body.classList.add('has-size-chart');
      document.querySelectorAll('.size-chart-button').forEach(btn => {
        btn.addEventListener('click', e => {
          //e.preventDefault();
          document.dispatchEvent(new SizeChartOpenEvent());
        })
      })

      document.addEventListener(ThemeEvents.sizeChartOpen, () => {
        //console.log('openSizeChart heard');
        let avadaButton = document.querySelector("#Avada-SC-button .Avada-inline-button");
        if(!avadaButton?.classList.contains('openning')){
          avadaButton?.classList.add('openning');
          document.querySelector("#Avada-SC-button .Avada-inline-button")?.click();
          setTimeout(() => {
            avadaButton?.classList.remove('openning');
          }, 1000)
        }
      })
      clearInterval( interval );
    } else if ( counter === limit ) {
      clearInterval ( interval );
    } 
  }, duration );
})();
